import React, { useEffect, useState } from "react";
import "./UpdateGallery.css";
import { Button, Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  RequestUpdateGalleryAction,
  SendUpdateGalleryAction,
} from "../Redux/UpdateGallery";
function UpdateGallery() {
  const dispatch = useDispatch();
  const [images, setImages] = useState([]);
  const [image, setImage] = useState([]);
  const [DataEntered, setDataEntered] = useState({
    UID: "",
    Name: "",
    Artist: "",
    Details: "",
    Dimensions: "",
    Price: "",
    Qty: "",
    Type: "",
    HashTags: "",
    Show: "",
    files:"",
    file:"",
  });

  const [errors, setErrors] = useState({});
  const posts = useSelector((state) => state.UpdateGallery);

  // const [imageURLS, setImageURLs] = useState([]);
  // useEffect(() => {
  //   if (images.length < 1) return;
  //   const newImageUrls = [];
  //   images.forEach((image) => newImageUrls.push(URL.createObjectURL(image)));
  //   setImageURLs(newImageUrls);
  // }, [images]);

  const onDataChange = (e) => {
    let Tmp = {};
    Tmp[e.target.name] = e.target.value;
    setDataEntered({ ...DataEntered, ...Tmp });
  };
  const onImagesChange = (e) => {
    setImages([...e.target.files]);
  };
  const onImageChange = (e) => {
    setImage([...e.target.files]);
  };
  const FindUID = (e) => {
    if (e.target.value !== "") {
      dispatch(RequestUpdateGalleryAction(e.target.value));      
    }
    setErrors({});
  };
  useEffect(() => {
    dispatch(RequestUpdateGalleryAction(""));
  }, [dispatch]);

  useEffect(() => {
    setDataEntered({ ...DataEntered, ...posts.data ,files:"",file:""});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posts.data]);

  const SubmitData = () => {
    //add validation
    const errors = {};
    if (DataEntered.UID.length === 0) {
      errors.UID = "Enter UID Number";
    } else if (!/^\d+$/.test(DataEntered.UID)) {
      errors.UID = "UID is not Number";
    }

    if (DataEntered.Qty.length === 0) {
      errors.Qty = "Enter Qty";
    } else if (!/^\d+$/.test(DataEntered.Qty)) {
      errors.Qty = "Qty is not Number";
    }
    if (DataEntered.Price.length === 0) {
      errors.Price = "Enter Price";
    } else if (!/^\d+$/.test(DataEntered.Qty)) {
      errors.Price = "Price is not Number";
    }
    if (DataEntered.Artist.length === 0) {
      errors.Artist = "Enter Artist";
    }
    if (DataEntered.Details.length === 0) {
      errors.Details = "Enter Details";
    }
    if (DataEntered.Dimensions.length === 0) {
      errors.Dimensions = "Enter Dimensions";
    }
    if (DataEntered.HashTags.length === 0) {
      errors.HashTags = "Enter HashTags";
    }
    if (DataEntered.Type.length === 0) {
      errors.Type = "Enter Type";
    }
    if (DataEntered.Name.length === 0) {
      errors.Name = "Enter Name";
    }

    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      dispatch(SendUpdateGalleryAction([DataEntered, image, images]));
    }
  };

  return (
    <Container fluid="fluid">
      <Container fluid="sm" className="Cointainer03 ">
        <h3 className="text-center">Update Gallery</h3>
        <div className="input-group">
          <span className="input-group-text" id="basic-addon1">
            UID
          </span>
          <input
            type="number"
            min="1"
            name="UID"
            className="form-control NumberInput"
            placeholder="Unique Id Number"
            aria-describedby="basic-addon1"
            value={DataEntered["UID"]}
            onChange={(e) => {
              onDataChange(e);
              FindUID(e);
            }}
          ></input>
        </div>
        {errors.UID && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.UID}
          </div>
        )}
        <div className="input-group">
          <span className="input-group-text" id="basic-addon2">
            Name
          </span>
          <input
            type="text"
            name="Name"
            className="form-control TextInput"
            placeholder="Name of Art"
            aria-describedby="basic-addon2"
            value={DataEntered["Name"]}
            onChange={(e) => onDataChange(e)}
          ></input>
        </div>
        {errors.Name && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.Name}
          </div>
        )}
        <div className="input-group ">
          <span className="input-group-text" id="basic-addon3">
            Artist
          </span>
          <input
            className="form-control  TextInput"
            name="Artist"
            placeholder="Name of Artist"
            aria-describedby="basic-addon3"
            value={DataEntered["Artist"]}
            onChange={(e) => onDataChange(e)}
            type="text"
          ></input>
        </div>

        {errors.Artist && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.Artist}
          </div>
        )}
        <div className="input-group ">
          <span className="input-group-text" id="basic-addon4">
            Details
          </span>
          <textarea
            className="form-control TextInput "
            name="Details"
            placeholder="Details of Art"
            type="text"
            aria-describedby="basic-addon4"
            value={DataEntered["Details"]}
            onChange={(e) => onDataChange(e)}
          ></textarea>
        </div>

        {errors.Details && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.Details}
          </div>
        )}
        <div className="input-group ">
          <span className="input-group-text" id="basic-addon5">
            Dimensions
          </span>
          <input
            className="form-control TextInput "
            name="Dimensions"
            placeholder="Dimensions eg. 47 x 47 inch's"
            type="text"
            aria-describedby="basic-addon5"
            value={DataEntered["Dimensions"]}
            onChange={(e) => onDataChange(e)}
          ></input>
        </div>

        {errors.Dimensions && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.Dimensions}
          </div>
        )}
        <div className="input-group">
          <span className="input-group-text" id="basic-addon6">
            Price
          </span>
          <input
            className="form-control TextInput"
            name="Price"
            placeholder="Price"
            type="number"
            min="1"
            value={DataEntered["Price"]}
            aria-describedby="basic-addon6"
            onChange={(e) => onDataChange(e)}
          ></input>
        </div>

        {errors.Price && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.Price}
          </div>
        )}
        <div className="input-group ">
          <span className="input-group-text" id="basic-addon7">
            Qty
          </span>
          <input
            className="form-control NumberInput"
            name="Qty"
            placeholder="Quantity available"
            type="number"
            min="0"
            aria-describedby="basic-addon7"
            value={DataEntered["Qty"]}
            onChange={(e) => onDataChange(e)}
          ></input>
        </div>

        {errors.Qty && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.Qty}
          </div>
        )}
        <div className="input-group ">
          <span className="input-group-text" id="basic-addon8">
            Type
          </span>
          <input
            className="form-control TextInput "
            name="Type"
            placeholder="Type of Art"
            aria-describedby="basic-addon8"
            type="text"
            value={DataEntered["Type"]}
            onChange={(e) => onDataChange(e)}
          ></input>
        </div>
        {errors.Type && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.Type}
          </div>
        )}
        <div className="input-group ">
          <span className="input-group-text" id="basic-addon9">
            HashTags
          </span>
          <textarea
            className="form-control TextInput "
            name="HashTags"
            placeholder="HashTags for Art to make Search Easy"
            type="text"
            aria-describedby="basic-addon9"
            value={DataEntered["HashTags"]}
            onChange={(e) => onDataChange(e)}
          ></textarea>
        </div>
        {errors.HashTags && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.HashTags}
          </div>
        )}

        <input
          className="form-control TextInput "
          type="file"
          id="files"
          name="file"
          value={DataEntered["file"]}
          accept="image/*"
        //   onChange={onImageChange}
        onChange={(e) => {
            onImageChange(e);
            onDataChange(e);
          }}
        />
        <input
          className="form-control TextInput "
          type="file"
          multiple
          name="files"
            value={DataEntered["files"]}
          id="files"
          accept="image/*"
          onChange={(e) => {
            onImagesChange(e);
            onDataChange(e);
          }}
         
        />

        <div className="input-group ">
          <span className="input-group-text" id="basic-addon10">
            Show
          </span>
          <select
            className="form-select"
            name="Show"
            aria-describedby="basic-addon10"
            value={DataEntered["Show"]}
            onChange={(e) => onDataChange(e)}
          >
            <option value="true">true</option>
            <option value="false">false</option>
          </select>
        </div>

        {/* let ImageDisplay = [];
            imageURLS.map((imageSrc) => (
            ImageDisplay.push(<Carousel.Item key={ imageSrc }>
            <img src={imageSrc} alt="Not Found" className="Photos02" /></Carousel.Item>
           ))) 
     <Carousel data-bs-theme="dark">{ImageDisplay}</Carousel> */}

        <label className={posts.isSuccess + " d-flex justify-content-center"}>
          Success
        </label>

        <Button className="Button11" onClick={() => SubmitData()}>
          Submit
        </Button>
      </Container>

      {posts.isLoading && (
        <div className="Loading03 d-flex justify-content-center ">
          <Spinner animation="border" variant="secondary" />
        </div>
      )}
    </Container>
  );
}

export default UpdateGallery;
